// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-bottom-sheet{border-radius:24px 24px 0 0!important;background:var(--v-white-base);display:grid;grid-template-rows:auto 1fr auto;padding:32px 24px 30px;position:relative;max-height:96vh!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
